import { Link, NavLink } from 'react-router-dom'
import './index.scss'
import LogoS from '../../assets/images/logo-s.png'
import LogoSubtitle from '../../assets/images/logo_sub.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faLinkedin,
    faGithub,
    faInstagram,
    faCodepen,
  } from '@fortawesome/free-brands-svg-icons'
  import {
    faHome,
    faUser,
    faEnvelope,
    faSuitcase,
    faBars,
    faClose,
  } from '@fortawesome/free-solid-svg-icons'
  import { useState } from 'react'



const Sidebar = () => {
    const [showNav, setShowNav] = useState(false);

    return(
    <div className='nav-bar'>
    <Link className='logo' to='/'
    onClick={() => setShowNav(false)}>>
        <img src={LogoS} alt="Logo" />
        <img className="sub-logo" src={LogoSubtitle} alt="slobodan" />
    </Link>
    <nav className={showNav ? 'mobile-show' : ''}>
        <NavLink exact="true" activeclassname="active" to="/" onClick={() => setShowNav(false)}>
            <FontAwesomeIcon icon={faHome} color="#4d4d4e" />
        </NavLink>
        <NavLink exact="true" activeclassname="active" className="about-link" to="/about" onClick={() => setShowNav(false)}>
            <FontAwesomeIcon icon={faUser} color="#4d4d4e" />
        </NavLink>
        <NavLink exact="true" activeclassname="active" className="portfolio-link" to="/portfolio" onClick={() => setShowNav(false)}>
            <FontAwesomeIcon icon={faSuitcase} color="#4d4d4e" />
        </NavLink>
        <NavLink exact="true" activeclassname="active" className="contact-link" to="/contact"  onClick={() => setShowNav(false)}>
            <FontAwesomeIcon icon={faEnvelope} color="#4d4d4e" />
        </NavLink>
       
    </nav>
    <ul>
        <li>
            <a target='_blank' rel='noreferrer' href='https://www.linkedin.com/in/ayushi-rathore-448a12259'>
                <FontAwesomeIcon icon={faLinkedin} color="#4d4d4e" />
            </a>
        </li>

        <li>
            <a target='_blank' rel='noreferrer' href='https://github.com/ayu-shiirathore'>
                <FontAwesomeIcon icon={faGithub} color="#4d4d4e" />
            </a>
        </li>

        <li>
            <a target='_blank' rel='noreferrer' href='https://leetcode.com/u/arathore22/'>
            <FontAwesomeIcon icon={faCodepen} color="#4d4d4e" />
            </a>
        </li>

        <li>
            <a target='_blank' rel='noreferrer' href='https://www.instagram.com/ayushi___rathore/'>
                <FontAwesomeIcon icon={faInstagram} color="#4d4d4e" />
            </a>
        </li>
    </ul>

    <FontAwesomeIcon 
          onClick={() => setShowNav(true)}
          icon={faBars}
          color="#ffd700"
          size="3x"
          className='hamburger-icon' />


    </div>
)
}

export default Sidebar